import React from 'react';
import { Grid2, Paper, Typography, Box, Divider, Stack } from '@mui/material';
import SessionsBChart from '../../Components/BarCharts/SessionsBChart';

import AbsentPresentChart from '../../Components/BarCharts/AbsentPresentChart';
import TutorsProgramWorkloadBar from '../../Components/BarCharts/TutorsProgramWorkloadBar';
import TutorLowPerformance from '../../Components/BarCharts/TutorLowPerformance';
import ProgramsBarChart from '../../Components/BarCharts/ProgramsBChart';
import TutorsBChart from '../../Components/BarCharts/TutorsBChart';
import LocalAnalytics from '../../Components/Analyics/LocalAnalytics';
import SessionsVsScoreScatterPlot from '../../Components/ScatterPlot/SessionsVsScoreScatterPlot';
import { useSelector } from 'react-redux';
import { fallback } from '../AdminHomeHelper';
import { ROOT } from '../../Static/static';
import Gate from '../Gate';

const OperationalTrends = ({ 
  programs,
  absenteeism,
  tutors,
  workload,
  sessionscore,
  lowPerformance
  }) => {

    const perms = useSelector((state) => state.role.permissions);
    const sysRole = useSelector((state) => state.role.role);
    const canGlobal = perms.includes("view:analytics:global");
    const canTutor  = perms.includes("view:analytics:tutor");
    const canProgram  = perms.includes("view:analytics:program");
    const canSession  = perms.includes("view:analytics:session");
    
    return (
      <Stack spacing={2}>
        {/* Row 1: The Main Activity Flow */}
        <Grid2 container spacing={2}>
        {/* Left Side - Single Paper */}
        <Grid2 size={{ xs: 12, md: 8 }}>
          <Paper variant="outlined" sx={{ p: 2, height: '100%' }}>
            <Typography variant="subtitle1" fontWeight={700} gutterBottom>
              Operations
            </Typography>
            <Box>
            <Gate allow={sysRole === ROOT || canTutor} fallback={fallback("view:analytics:tutor")}>
              <TutorsBChart data={tutors} />
              </Gate>
            </Box>
            <Divider />
            <Box>
              <Gate allow={sysRole === ROOT || canSession} fallback={fallback("view:analytics:session")}>
                <SessionsVsScoreScatterPlot data={sessionscore} />
              </Gate>
            </Box>
            
          </Paper>
        </Grid2>
        
        {/* Right Side - Stacked Papers with Equal Total Height */}
        <Grid2 size={{ xs: 12, md: 4 }}>
          <Stack spacing={2} sx={{ height: '100%' }}>
            {/* Top Paper - Takes up remaining space */}
            <Paper variant="outlined" sx={{ p: 2, flex: 1 }}>
              <Typography variant="subtitle1" fontWeight={700} gutterBottom>
                Engagement Health
              </Typography>
              <Box>
              <Gate allow={sysRole === ROOT || canGlobal} fallback={fallback("view:analytics:global")}>
                <AbsentPresentChart counts={absenteeism} />
                </Gate>
              </Box>
            </Paper>
            
            {/* Bottom Paper - Takes up remaining space */}
            <Paper variant="outlined" sx={{ p: 2, flex: 1 }}>
              <Box>
                <Gate allow={sysRole === ROOT || canProgram} fallback={fallback("view:analytics:program")}>
                  <ProgramsBarChart data={programs} />
                </Gate>
              </Box>
            </Paper>
          </Stack>
        </Grid2>
      </Grid2>
  
        {/* Row 2: Program & Tutor Capacity */}
        <Grid2 container spacing={2} sx={{ display: 'flex', alignItems: 'stretch' }}>
          <Grid2 size={{ xs: 12, md: 6 }} sx={{ 
            p: 1, 
            height: '100%',    
            display: 'flex',    
            flexDirection: 'column' 
          }}>
            <Paper variant="outlined" sx={{ p: 1, height: '100%' }}>
              <Gate allow={sysRole === ROOT || canTutor} fallback={fallback("view:analytics:tutor")}>
                <TutorLowPerformance data={lowPerformance} />
              </Gate>
            </Paper>

          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}sx={{ 
            p: 1, 
            height: '100%',     
            display: 'flex',    
            flexDirection: 'column' 
          }}>
            <Paper variant="outlined" sx={{ p: 1, height: '100%' }}>
              <Gate allow={sysRole === ROOT || canTutor} fallback={fallback("view:analytics:tutor")}>
              <TutorsProgramWorkloadBar data={workload} />
              </Gate>
            </Paper>
          </Grid2>
        </Grid2>
      </Stack>
    );
  };
  
  export default OperationalTrends;